import styled from "styled-components";

export const Container = styled.div`
  height: 80px;
  width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.COLORS.SECONDARY};
  cursor: pointer;
  margin-block: 10px;

   @media (max-width: 360px) {
         width: 90%;
    }
     @media (max-width: 768px) {
         width: 90%;
    }
`;
export const SubContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export const ContainerImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Logo = styled.img`
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
export const ContainerText = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`;
export const Title = styled.h3`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 16px;
  font-weight: 700;
  margin: 0;
`;
export const Description = styled.p`
  color: ${({ theme }) => theme.COLORS.DESCRIPTION};
  font-size: 15px;
  font-weight: 500;
  margin: 0;
`;
export const SelectCircle = styled.div`
    width: 25px;
    height: 25px;
    border: 2px solid ${({ theme }) => theme.COLORS.TEXT_DETAILS};
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.COLORS.SUB_BACKGROUND};
`;
export const Circle = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.COLORS.PRIMARY};
`;